import { render, staticRenderFns } from "./Bug.vue?vue&type=template&id=7ce9f4c4&scoped=true"
import script from "./Bug.vue?vue&type=script&lang=ts"
export * from "./Bug.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9f4c4",
  null
  
)

export default component.exports